import { Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import React from 'react';

import BranchSystemCreate from './BranchSystemCreate';

// eslint-disable-next-line react/function-component-definition
export default function CodingCreateDialog({
  onClose,
  open,
  selected,
  handleConfirm,
}) {
  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <Box sx={{ p: 3, direction: 'rtl' }}>
        <BranchSystemCreate
          branchGuid={selected}
          onEditComplete={handleConfirm}
        />
      </Box>
    </Dialog>
  );
}
